import { queryOptions } from "@tanstack/react-query";

import type { DeliverabilityRange } from "./server";
import { getDeliverabilityView } from "./server-fns";

type DeliverabilityFilters = {
  range: DeliverabilityRange;
  domainId?: string;
  aliasId?: string;
};

export function deliverabilityQueryKey(filters: DeliverabilityFilters) {
  return ["deliverability", filters] as const;
}

export function deliverabilityQueryOptions(filters: DeliverabilityFilters) {
  return queryOptions({
    queryKey: deliverabilityQueryKey(filters),
    queryFn: () =>
      getDeliverabilityView({
        data: {
          range: filters.range,
          domainId: filters.domainId,
          aliasId: filters.aliasId,
        },
      }),
    staleTime: 30_000,
  });
}
